// Custom translation hook that combines i18next with our language context
import { useTranslation as useI18nextTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

/**
 * Custom hook that wraps i18next's useTranslation
 * Provides translation function and language management
 *
 * @param {string} namespace - Translation namespace (e.g., 'common', 'home')
 * @returns {object} - Translation utilities
 */
export const useTranslation = (namespace = 'common') => {
  const { t, i18n, ready } = useI18nextTranslation(namespace);
  const { currentLanguage, changeLanguage, getLocalizedPath, supportedLanguages } = useLanguage();

  return {
    // Translation function
    t,

    // Language information
    currentLanguage,
    supportedLanguages,

    // Language management
    changeLanguage,
    getLocalizedPath,

    // i18next instance (for advanced usage)
    i18n,

    // Ready state (for loading indicators)
    ready,
  };
};

export default useTranslation;
